export interface AgentLookupResponse {
  id: number;
  name: string;
  firstName?: string | null;
  lastName?: string | null;
  email?: string | null;
  avatarUrl?: string | null;
  active: boolean;

  teamIds?: number[];
  teams?: Array<{ id: number; name: string }>;
  team?: string | null;

  status?: string | null;
  presence?: 'AVAILABLE' | 'BUSY' | 'AWAY' | 'OFFLINE' | 'ONLINE' | string | null;

  languageCodes?: string[];

  maxConcurrentChats?: number | null;
  activeConversationCount?: number | null;
  canReceiveNewChats?: boolean;

  isContactOwnerEligible?: boolean;
}

export interface TeamLookupResponse {
  id: number;
  name: string;
  description?: string | null;
  active: boolean;

  memberCount?: number | null;
  availableMemberCount?: number | null;

  languageCodes?: string[];

  maxConcurrentChats?: number | null;
  activeConversationCount?: number | null;
  canReceiveNewChats?: boolean;
}

export interface TeamMemberLookupResponse {
  id: number;
  name: string;
  email?: string | null;
  presence?: string | null;
  languageCodes?: string[];
  maxConcurrentChats?: number | null;
  activeConversationCount?: number | null;
  canReceiveNewChats?: boolean;
}

export interface AgentLookupParams {
  teamId?: number;
  availableOnly?: boolean;
  languageCode?: string;
  includePresence?: boolean;
  includeCapacity?: boolean;
}

export interface TeamLookupParams {
  activeOnly?: boolean;
  includeMembers?: boolean;
  languageCode?: string;
}

export const PRESENCE_LABELS: Record<string, string> = {
  AVAILABLE: 'Disponible',
  BUSY: 'Ocupado',
  AWAY: 'Ausente',
  OFFLINE: 'Offline',
  ONLINE: 'Online'
};

export function agentDisplayLabel(agent: AgentLookupResponse): string {
  const name = agent.name || agent.firstName || agent.email || `Agente #${agent.id}`;
  const teamName = agent.teams?.[0]?.name ?? agent.team ?? null;
  const presenceLabel = agent.presence ? PRESENCE_LABELS[agent.presence] ?? agent.presence : null;

  let label = name;
  if (teamName) label += ` (${teamName})`;
  if (presenceLabel) label += ` · ${presenceLabel}`;
  if (agent.canReceiveNewChats === false) label += ' · Saturado';
  return label;
}

export function teamDisplayLabel(team: TeamLookupResponse): string {
  let label = team.name;
  if (team.availableMemberCount != null && team.memberCount != null) {
    label += ` · ${team.availableMemberCount} disponibles de ${team.memberCount}`;
  }
  if (team.canReceiveNewChats === false) label += ' · Sin agentes disponibles';
  return label;
}
